export const socialLinks = [
	{
		id: 1,
		name: 'Website',
		icon: 'globe',
		url: 'https://www.ludere.cn/',
	},
	{
		id: 2,
		name: '小黑盒',
		icon: 'box',
		url: 'https://www.xiaoheihe.cn/',
	},
	{
		id: 3,
		name: 'Bilibili',
		icon: 'tv',
		url: 'https://www.bilibili.com/',
	},
	{
		id: 4,
		name: '小红书',
		icon: 'book',
		url: 'https://www.xiaohongshu.com/',
	}
];
